/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { ScreenCapture } from "react-screen-capture";
import html2canvas from "html2canvas";
import axios from "axios";
import FloatingButton from "../Components/FloatingButton/FloatingButton";
import { ScreenRecorder } from "./ScreenRecorder";
import BottomButtons from "../Components/BottomButtons/BottomButtons";
import SupportSummary from "./SupportSummary";
import { createIssue } from "../network/apiService";
import Popup from "../Components/Popup";

export const SupportButton = ({
  profileData,
  supportIconHandler,
  open,
  anchorEl,
  setOpen,
  parentStyle,
  consumerId
}) => {
  const [screenRecorder, setScreenRecorder] = useState(false);
  const [type, setType] = useState("none");
  const [showRecordModal, setShowRecordModal] = useState(false);
  const [showFloat, setShowFloat] = useState(false);
  const [showFloating, setFloating] = useState(false);
  const [screenshot, setscreenshot] = useState({});
  const [screenCaptured, setscreenCaptured] = useState(false);
  const [openCanvaModal, setopenCanvaModal] = useState(false);
  const [openSSModal, setopenSSModal] = useState(false);
  const [FormSubmit, setFormSubmit] = useState(false);
  const [select, setSelect] = useState(true);

  const handleScreenCapture = (screenCapture) => {
    setscreenshot({ screenCapture });
    setscreenCaptured(true);
    setopenSSModal(true);
    setType("shotTaken");
  };

  const handleFullScreenCapture = () => {
    const screenshotTarget = document.body;

    html2canvas(screenshotTarget).then((canvas) => {
      const image = canvas.toDataURL("image/png");
      setscreenshot({ screenCapture: image });
    });

    setscreenCaptured(true);
    setopenSSModal(true);
    setType("shotTaken");
  };


  const { screenCapture } = screenshot;

  if (FormSubmit) {
    setFormSubmit(false);
  }

  const handleRecordFlow = (redcording) => {
    setOpen(false);
    setShowRecordModal(true);
    // setScreenCapture(screenCapture);
    setScreenRecorder(true);
  };

  return (
    <>
      <ScreenCapture onEndCapture={handleScreenCapture}>
        {({ onStartCapture }) => {
          return (
            <div>
              {/* <img className='blue' src={TestPng} alt='kuch bi' /> */}
              <FloatingButton
                handleRecordFlow={handleRecordFlow}
                setType={setType}
                showFloat={showFloat}
                setFloating={setFloating}
                setShowRecordModal={setShowRecordModal}
                showRecordModal={showRecordModal}
                parentStyle={parentStyle}
                select={select}
                setSelect={setSelect}
              />
              <BottomButtons
                handleFullScreenCapture={handleFullScreenCapture}
                type={type}
                setType={setType}
                onStartCapture={onStartCapture}
                setCanvaOpenModal={setopenCanvaModal}
                openSSModal={openSSModal}
                setSSOpenModal={setopenSSModal}
                screenCapture={screenCapture}
                showFloat={showFloat}
                setShowFloat={setShowFloat}
                parentStyle={parentStyle}
              />
              <Popup
                profileData={profileData}
                screenCapture={screenCapture}
                openCanvaModal={openCanvaModal}
                setCanvaOpenModal={setopenCanvaModal}
                setFormSubmit={setFormSubmit}
                parentStyle={parentStyle}
                select={select}
                setSelect={setSelect}
                consumerId={consumerId}
              />
            </div>
          );
        }}
      </ScreenCapture>

      {screenRecorder && (
        <ScreenRecorder
          profileData={profileData}
          setShowRecordModal={setShowRecordModal}
          showRecordModal={showRecordModal}
          showFloat={showFloat}
          setShowFloat={setShowFloat}
          parentStyle={parentStyle}
          consumerId={consumerId}
        />
      )}
    </>
  );
};

export default SupportButton;
